import { and, asset, count, eq, type PowerSyncDrizzleDB } from "@tendly/powersync";
import { liveAssetFilters } from "./filters";

/**
 * Counts a user's LIVE assets. Feeds `checkUnsyncedActor` (the
 * "Keep local data?" prompt when migrating from guest to real account): it
 * previously did a raw `count() from(asset)` in `auth/controllers.ts`,
 * counting trash too (a scattered invariant bug, the same family as the ⌘K/checkUnsynced
 * from the pilot). Through the live layer it only counts live assets — consistent with
 * the rest of the views. (The guest→real merge still runs unconditionally via
 * `sweepVisitorData`, so no row is lost; this counter only decides
 * whether the prompt is SHOWN.)
 */
export function getLiveAssetCountForUserQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({ total: count() })
    .from(asset)
    .where(and(eq(asset.user_id, userId), ...liveAssetFilters()));
}
